import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { IParticipant } from '../../models/IEvent';
import { IEventItem } from '../../models/IEventItem';
import { ItemService } from '../../services/item.service';
import { Observable, Subscription } from 'rxjs';
import { IItem } from '../../models/IItem';
import { map } from 'rxjs/operators';

@Component({
  selector: 'participant',
  templateUrl: './participant.component.html',
  styleUrls: ['./participant.component.scss']
})
export class ParticipantComponent implements OnInit, OnDestroy {
  @Input() participant: IParticipant;
  @Input() participantItems: any[];

  items: IItem[];
  subscription: Subscription;

  hovered;
  constructor(private itemService: ItemService) { }

  ngOnInit(): void {
    this.subscription = this.itemService.getAll().subscribe(r => this.items = r);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getName(id: string) {
    if (id.length > 10) {
      return this.items.filter(i => i.id === id)[0].name;
    } else {
      return this.participantItems.filter(i => i.id === id)[0].name;
    }
  }

  getImage(id: string) {
    if (id.length > 10) {
      return this.items.filter(i => i.id === id)[0].image;
    } else {
      return 'https://firebasestorage.googleapis.com/v0/b/froodini-d5dad.appspot.com/o/items%2Fcrane_200x200.png?alt=media&token=c53f5e17-a583-4044-bb3c-3779379c8828';
    }
  }

}
